<template>
    <el-dialog
        title="Add a new slider"
        width="1080px"
        :visible="show"
        :before-close="beforeClose"
        :append-to-body="true"
        @close="onCancelClick"
    >
        <el-form :model="form" ref="form" label-width="160px" label-position="right" :rules="rules">
            <el-form-item label="Title" prop="title">
                <el-input v-model="form.title" autocomplete="off" placeholder="Title" clearable></el-input>
            </el-form-item>
            <el-form-item label="Description" prop="description">
                <ckeditor :editor="editor" v-model="form.description" :config="editorConfig" ></ckeditor>
                <!-- <el-input
                    type="textarea"
                    v-model="form.description"
                    autocomplete="off"
                    clearable
                    maxlength="255"
                    show-word-limit
                ></el-input> -->
            </el-form-item>
            <el-form-item label="Sort order" prop="sort_order">
                <el-input-number v-model="form.sort_order" :min="0" :max="20" label="Sotr order"></el-input-number>
            </el-form-item>
            <el-upload
                name="file"
                ref="upload"
                action="#"
                class="receipt-upload"
                :file-list="fileList"
                :auto-upload="false"
                :multiple="false"
                :limit="1"
                v-if="!data" 
            >
                <el-button class="upload-btn" type="primary">
                    <i class="el-icon-upload"></i> Upload slider photo
                </el-button>
            </el-upload>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="onCancelClick">Cancel</el-button>
            <el-button @click="onSubmit" type="primary">Save</el-button>
            <el-button v-if="data" @click="onDelete" type="primary">Delete</el-button>
        </div>
    </el-dialog>
</template>

<script>
// @ is an alias to /src
import { mapActions, mapState } from "vuex";
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export default {
    name: "AdimSliderNew",
    props: {
        data: Object,
        show: { default: false },
        onClose: Function
    },
    components: {},
    data() {
        return {
            editor: ClassicEditor,
            form: {
                title: "",
                description: "",
                sort_order: 0
            },
            rules: {
                title: [
                    {
                        required: true,
                        message: "Title is required",
                        trigger: "blur"
                    }
                ],
                description: [
                    {
                        required: true,
                        message: "Description is required",
                        trigger: "blur"
                    }
                ]
            },
            processing: false,
            fileList: []
        };
    },
    watch: {
        data(newData) {
            if (newData) {
                this.form.title = newData.title;
                this.form.description = newData.description;
                this.form.sort_order = newData.sort_order;
            }
        }
    },
    mounted() {
        if (this.data) {
            this.form.title = this.data.title;
            this.form.description = this.data.description;
            this.form.sort_order = this.data.sort_order;
        }
    },
    computed: {
        ...mapState({
            accessToken: state => state.accessToken,
            editorConfig: state => state.editorConfig,
        })
    },
    methods: {
        ...mapActions(["request", "getError"]),
        beforeClose(done = () => {}) {
            this.form.title = "";
            this.form.description = "";
            this.form.sort_order = 0;
            this.fileList = [];
            done();
        },
        onCancelClick(reload = true) {
            this.onClose(reload);
        },
        validateForm() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    return true;
                } else {
                    return false;
                }
            });
        },
        onDelete() {
            let ctrl = this;
            ctrl.$confirm(
                "Do you wish to delete this slide?",
                "Delete slide",
                {
                    confirmButtonText: `Confirm`,
                    cancelButtonText: "Cancel",
                    type: "warning"
                }
            )
                .then(() => {
                    ctrl.processing = true;
                    ctrl.request({
                        method: "DELETE",
                        endpoint: `site_content/slider/${ctrl.data.id}`
                    })
                        .then(() => {
                            this.$message({
                                message: "Slide has been deleted",
                                type: "success"
                            });
                            ctrl.onCancelClick(true);
                        })
                        .catch(err => {
                            ctrl.getError({
                                err,
                                title: "SITE_CONTENT_ERROR",
                                message: "Delete Slide Failed"
                            }).then(ctrl.$notify);
                        })
                        .finally(() => {
                            ctrl.processing = false;
                        });
                })
                .catch(() => {});
        },
        onSubmit() {
            let ctrl = this;
            this.$refs.form.validate(valid => {
                if (valid) {
                    ctrl.processing = true;
                    let fileArray = [];

                    let method = "POST";
                    let endpoint = `site_content/slider`;

                    if (ctrl.data) {
                        method = "PATCH";
                        endpoint = `site_content/slider/${ctrl.data.id}`;
                    }
                    let options = {
                        method,
                        endpoint,
                        data: ctrl.form
                    };
                    if (!ctrl.data) {
                        fileArray = this.$refs.upload.uploadFiles;
                        if (fileArray.length == 0) {
                            ctrl.getError({
                                title: "HOME_CONTENT_ERROR",
                                message: "Slide photo required"
                            }).then(ctrl.$notify);
                            return;
                        }
                        let data = new FormData();
                        for (let file of fileArray) {
                            data.append("file", file.raw);
                        }
                        for (let field_name in ctrl.form) {
                            data.append(field_name, ctrl.form[field_name]);
                        }
                        options.data = data;
                        options.headers = {
                            "Content-Type": "application/x-www-form-urlencoded",
                            Authorization: "Bearer " + this.accessToken
                        };
                    }
                    ctrl.request(options)
                        .then(() => {
                            if (ctrl.data) {
                                this.$message({
                                    message:
                                        "Home page slider has been updated",
                                    type: "success"
                                });
                            } else {
                                this.$message({
                                    message: "New slider has been added",
                                    type: "success"
                                });
                            }
                            setTimeout(() => {
                                ctrl.onCancelClick(true);
                            }, 1000);
                        })
                        .catch(err => {
                            ctrl.getError({
                                err,
                                title: "HOME_CONTENT_ERROR",
                                message: "Add Slider Failed"
                            }).then(ctrl.$notify);
                        })
                        .finally(() => {
                            ctrl.processing = false;
                        });
                } else {
                    return false;
                }
            });
        }
    }
};
</script>
<style scoped>
.slider-list {
    background-color: #eee;
}

.new-permission-btn {
    width: 100%;
    line-height: 50px;
    cursor: pointer;
    color: #fff;
    text-align: center;
    border: 1px solid #eee;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}
.new-permission-btn:hover {
    color: #fff;
    background-color: #00669a;
}

.new-permission-btn:active {
    color: #fff;
    background-color: #177CB0;
}
.load-more {
    width: 100%;
    line-height: 50px;
    cursor: pointer;
    color: #fff;
    text-align: center;
    border: 1px solid #eee;
    margin-top: 16px;
}
.load-more:hover {
    color: #fff;
    background-color: #00669a;
}

.load-more:active {
    color: #fff;
    background-color: #177CB0;
}
</style>

<style >
.slider-list-item {
    cursor: pointer;
}
</style>